import React, { useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';


function ContactPage({handleContact, handleComplete}) {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('65');
  const [error, setError] = useState('');

  const validatePhoneNumber = (num) => {
    let sgNum = num.slice(0,2) === '65';
    if (num.length >= 10){
      if (sgNum && num.length > 10)
      {
        setError("Phone Number should not exceed 8 digits");
        return true;
      }
      setError('');
      return false;
    } else {
      setError("Phone Number should be at least 8 digits (excluding country code)");
      return true;
    }
  }

  const handleChange = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, '');
    e.target.value = onlyDigits;
    setNumber(e.target.value === '' ? 0 : e.target.value);
    
    validatePhoneNumber(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (error || validatePhoneNumber(number)) return;

    handleContact({name, number});
  }
  
  return (
    <div className='w-full h-screen m-5 relative flex justify-center items-center font-bold text-[#223641]'>
      <img className='absolute top-0 right-0' src={process.env.PUBLIC_URL + '/logo.png'} alt='logo'/>
      <div>
        <h1 className='italic text-xl my-10'>Please provide us your <u>Name</u> and <u>Contact Number</u></h1>
        <form onSubmit={handleSubmit} className='flex flex-col w-4/5 items-center justify-self-center gap-4' >
          <TextField
              required
              label="Name"
              value={name}
              style={{width: '100%'}}
              onChange={e => setName(e.target.value)}
            />
          <TextField
              required
              label="Contact Number"
              type='tel'
              value={number === 0 ? '' : number}
              style={{width: '100%'}}
              slotProps={{
                input: {
                  startAdornment: <InputAdornment position="start">+</InputAdornment>,
                },
                htmlInput: {
                  inputMode: 'numeric',
                  pattern: '[0-9]*'
                }
              }}
              onChange={handleChange}
              error={error}
              helperText={error ? error : ''}
            />
            <div className='w-full flex flex-row'>
              <button className='underline px-4 py-3 rounded-md m-2' type='button' onClick={handleComplete}>Cancel</button>
              <button className='grow bg-[#223641] text-white py-3 rounded-md m-2' type='submit'>Submit</button>
            </div>
        </form> 
      </div>
    </div>
  );
}

export default ContactPage;